import DOMPurify from 'dompurify'
import { formatDateTime } from '_metronic/helpers'
import { TIPO_TERMO_LABELS, TermoConsentimento, TipoTermoConsentimento } from '../../core/_models'
import {
  DetailBadge,
  DetailField,
  DetailFields,
  DetailHeader,
  DetailPanel,
  DetailSection,
  FetchState,
  useModal,
} from '../../../../../components'
import styles from './styles/TermoDetailModal.module.css'

export const TermoDetailModal: React.FC = () => {
  const { fetchStates } = useModal()
  const { data: termo, isLoading } = (fetchStates['termo'] || {}) as FetchState<TermoConsentimento>

  if (!isLoading && !termo) return null

  return (
    <DetailPanel isLoading={isLoading} loadingLabel='Carregando o termo…'>
      {termo && (
        <>
          <DetailHeader
            title={termo.titulo}
            meta={[`Versão ${termo.versao}`]}
            badge={
              <DetailBadge tone={termo.publicado ? 'success' : 'neutral'}>
                {termo.publicado ? 'Publicado' : 'Inativo'}
              </DetailBadge>
            }
          />
          <DetailFields>
            <DetailField
              label='Destinatário'
              value={TIPO_TERMO_LABELS[termo.tipo ?? TipoTermoConsentimento.Paciente]}
            />
            <DetailField
              label='Criado em'
              value={termo.createdAt && formatDateTime(termo.createdAt)}
            />
            <DetailField
              label='Início da vigência'
              value={termo.dtVigenciaInicio && formatDateTime(termo.dtVigenciaInicio)}
            />
            <DetailField
              label='Fim da vigência'
              value={termo.dtVigenciaFim && formatDateTime(termo.dtVigenciaFim)}
              emptyLabel='Sem data de término'
            />
            <DetailField
              label='Hash SHA-256'
              value={termo.hash && <code className={styles.hash}>{termo.hash}</code>}
              wide
            />
          </DetailFields>
          <DetailSection title='Conteúdo'>
            {/* HTML do termo vem da API: sempre sanitizado (regra do projeto). */}
            <div
              className={styles.conteudo}
              tabIndex={0}
              aria-label='Conteúdo do termo'
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termo.conteudo) }}
            />
          </DetailSection>
        </>
      )}
    </DetailPanel>
  )
}
